import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiRequest } from '../../api/client';
import './SwipePromo.css';

const image = (path: string) => `https://image.tmdb.org/t/p/w342${path}`;
// How well we know you, by how many films and actors you've answered.
export const tasteLevels = [{ at: 0, name: 'Just met' }, { at: 10, name: 'Getting to know you' }, { at: 30, name: 'Film buff' }, { at: 60, name: 'Taste twin' }, { at: 120, name: 'Mind reader' }];
export const tasteLevel = (answered: number) => {
  const index = tasteLevels.reduce((found, level, i) => (answered >= level.at ? i : found), 0);
  const current = tasteLevels[index], next = tasteLevels[index + 1];
  return { name: current.name, next: next?.name || null, toNext: next ? next.at - answered : 0, progress: next ? (answered - current.at) / (next.at - current.at) : 1 };
};

const stamps = [{ text: 'SEEN IT', tone: 'green', dir: 'right' }, { text: 'NOT SEEN', tone: 'red', dir: 'left' }, { text: 'WATCHLIST', tone: 'violet', dir: 'up' }];

// A little self-playing swipe deck that shows how the feature works, plus your progress towards the next taste level.
const SwipePromo = ({ posters }: { posters: string[] }) => {
  const [taste, setTaste] = useState<any>(null);
  useEffect(() => { apiRequest<any>('/taste').then(setTaste).catch(() => undefined); }, []);
  const films = taste?.totals?.answered || 0;
  const actors = taste?.actors ? taste.actors.like + taste.actors.dislike + taste.actors.unknown + taste.actors.neutral : 0;
  const level = tasteLevel(films + actors);
  const actor = [...(taste?.favourites || []), ...(taste?.topActors || [])].find((person: any) => person.profilePath);
  const cards = posters.slice(0, 3).map((path, index) => ({ src: image(path), ...stamps[index] }));
  if (actor) cards.splice(1, 0, { src: image(actor.profilePath), text: 'LOVE THEM', tone: 'green', dir: 'right' });

  return <section className="home-section">
    <div className="swipe-promo2">
      <div className="sp-stage" aria-hidden="true">
      <div className="sp-deck" style={{ ['--cards' as any]: cards.length }}>
        {cards.map((card, index) => <div key={card.src} className={`sp-card sp-card--${card.dir}`} style={{ ['--i' as any]: index, backgroundImage: `url(${card.src})` }}><span className={`sp-stamp tone-${card.tone}`}>{card.text}</span></div>)}
      </div>
      </div>
      <div className="sp-text">
        <p>TEACH US YOUR TASTE</p>
        <h2>Swipe right on films you’ve seen.</h2>
        <span>Left if you haven’t, up to save for later. Then do the same with actors. Every swipe sharpens your picks.</span>
        <div className="sp-level">
          <div className="sp-level__top"><strong>{level.name}</strong>{level.next && <small>{level.toNext} more to “{level.next}”</small>}</div>
          <div className="sp-level__bar"><span style={{ width: `${Math.max(4, level.progress * 100)}%` }} /></div>
          <small>{films + actors ? `You’ve answered ${films} film${films === 1 ? '' : 's'} and ${actors} actor${actors === 1 ? '' : 's'}.` : 'You haven’t swiped yet. It takes about a minute.'}</small>
        </div>
        <div className="sp-actions"><Link to="/swipe" className="sp-primary">🎬 Swipe films</Link><Link to="/swipe?type=actors" className="sp-secondary">🎭 Swipe actors</Link></div>
      </div>
    </div>
  </section>;
};

export default SwipePromo;
